// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15kVP","name":"styles_name__kJIBK","phone":"styles_phone__YRVrg"};